/**作品路由 */
export default [
    {
        name:'agent',
        path:'agent',
        meta: { title: '代理商管理' },
        component: ()=>import('@/pages/agent/index.vue')
    }
]